<template>
  <div class="main" :class="{ 'has-touch-scroll-frame': hasTouchScrollableFrame }">
    <v-sheet>
      <TipTapReader
        v-if="options.content"
        class="tiptap_style"
        :options="options"
        :key="componentKey"
        @hook:mounted="scheduleTouchScrollableFrames"
      />
    </v-sheet>
    <div class="bottomFixedButton" :class="hasPromotionCode() ? 'd-flex' : 'd-none'">
      <v-btn large width="50%" color="primary" style="font-size: 25px" class="rounded-10 darken-1" depressed @click="goReserve">
        {{ $t("button.do-reserve") }}
      </v-btn>
    </div>
  </div>
</template>
<script>
import TipTapReader from "@/components/tiptap/Reader"
import { mapState } from "vuex"
export default {
  components: {
    TipTapReader,
  },
  data: () => ({
    //TipTap
    options: {
      content: "",
      readonly: true,
      editable: true,
      supportImage: true,
      supportVideo: true,
    },
    componentKey: 0,
    hasTouchScrollableFrame: false,

    eventData: {},
  }),

  mounted() {
    console.log("event: ", this.$route.params.eventCode)
    this.frameObserver = new MutationObserver(() => this.scheduleTouchScrollableFrames())
    this.frameObserver.observe(this.$el, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "height", "scrolling"],
    })
    this.$http
      .get("/api/event/select/code", {
        params: {
          code: this.$route.params.eventCode,
        },
      })
      .then((res) => {
        this.eventData = res.data[0]
        this.options.content = this.getContent()
        this.componentKey++
      })
  },
  beforeDestroy() {
    if (this.frameObserver) {
      this.frameObserver.disconnect()
    }
  },
  watch: {
    lang() {
      this.options.content = this.getContent()
      this.componentKey++
    },
  },

  computed: {
    ...mapState(["lang"]),
  },

  methods: {
    scheduleTouchScrollableFrames() {
      this.$nextTick(() => {
        window.requestAnimationFrame(() => this.configureTouchScrollableFrames())
      })
    },
    configureTouchScrollableFrames() {
      const longFrames = Array.from(this.$el.querySelectorAll("iframe")).filter((frame) => {
        const configuredHeight = parseFloat(frame.style.height || frame.getAttribute("height") || "0")
        return configuredHeight > window.innerHeight * 1.5
      })

      longFrames.forEach((frame) => {
        if (frame.getAttribute("scrolling") !== "yes") {
          frame.setAttribute("scrolling", "yes")
        }
        frame.classList.add("touch-scroll-frame")
        if (frame.parentElement) {
          frame.parentElement.classList.add("touch-scroll-frame-wrapper")
        }
      })
      this.hasTouchScrollableFrame = longFrames.length > 0
    },
    getContent() {
      if (!this.eventData) {
        return ""
      }
      switch (this.lang) {
        case "jp":
          return this.eventData.content_jp || this.eventData.content
        case "en":
          return this.eventData.content_en || this.eventData.content
        default:
          return this.eventData.content || ""
      }
    },
    hasPromotionCode() {
      return this.eventData.promotionCode ? true : false
    },
    goReserve: _.debounce(function () {
      console.log("goReserve")
      // 예약하기 화면으로 이동. 행사 소개는 여기서 읽었으니 예약 칸을 먼저 보이고 소개는 그 아래로(10/17)
      this.$router.push({ path: "/booking/reserve", query: { event: this.eventData.promotionCode, bookingIntro: "after" } })
    }, 500),
  },
}
</script>
<style scoped>
.main {
  position: relative;
  overflow-y: auto;
  padding-bottom: 100px !important;
}
.bottomFixedButton {
  max-width: 580px;
  width: 100%;
  height: 100px;
  position: fixed;
  bottom: 72px;
  padding-bottom: 10px;
  border-top: 1px solid #e0e0e0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
}

.main.has-touch-scroll-frame {
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  padding-bottom: calc(66px + env(safe-area-inset-bottom, 0px)) !important;
}
.main.has-touch-scroll-frame > .v-sheet,
.main.has-touch-scroll-frame ::v-deep .tiptap_style,
.main.has-touch-scroll-frame ::v-deep .tiptap_style > div,
.main.has-touch-scroll-frame ::v-deep .ProseMirror {
  height: 100%;
  overflow: hidden;
}
.main.has-touch-scroll-frame ::v-deep .iframe-wrapper.touch-scroll-frame-wrapper {
  height: 100%;
  aspect-ratio: auto !important;
  overflow: hidden;
}
.main.has-touch-scroll-frame ::v-deep iframe.touch-scroll-frame {
  display: block;
  height: 100% !important;
  max-height: none !important;
  aspect-ratio: auto !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
}
</style>
